export const CHIC_URL = import.meta.env.VITE_CHIC_URL;
